import { render, staticRenderFns } from "./FavoritesChart.vue?vue&type=template&id=200ea18a&scoped=true&"
import script from "./FavoritesChart.vue?vue&type=script&lang=js&"
export * from "./FavoritesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200ea18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200ea18a')) {
      api.createRecord('200ea18a', component.options)
    } else {
      api.reload('200ea18a', component.options)
    }
    module.hot.accept("./FavoritesChart.vue?vue&type=template&id=200ea18a&scoped=true&", function () {
      api.rerender('200ea18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Includes/Charts/VideoStats/FavoritesChart.vue"
export default component.exports